import type { Customer } from './types'

// Id zero mantém a jornada sem cadastro vinculado; o nome é copiado nos bilhetes.
export const ANONYMOUS_CUSTOMER: Customer = {
  id: 0,
  nome: 'AUTOATENDIMENTO',
  cpf: '—',
  telefone: '—',
  email: '',
}

export const isAnonymousCustomer = (customer: Customer | null): boolean =>
  !!customer && customer.id === 0 && customer.nome === ANONYMOUS_CUSTOMER.nome

export const isTerminalCustomerEmail = (email?: string | null): boolean =>
  !!email?.trim().toLowerCase().endsWith('@terminal.filazero.net')
